import Initializer from './components/Initializer';
import pluginId from './pluginId';

export default {
  register(app: any) {
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
    });
  },
};
